import React from "react";
import { StaticQuery, graphql, Link } from "gatsby";
import { FiMenu } from "react-icons/fi";
import "../styles/custom.tachyons.css";
import "tachyons";

const MultiLink = (props) => {
  const internal = /^\/(?!\/)/.test(props.to);
  let result;
  if (internal) {
    result = (
      <Link
        to={props.to}
        className={props.className}
        style={{ color: "white" }}
        key={"home3"}
      >
        {props.children}
      </Link>
    );
  } else {
    result = (
      <a
        href={props.to}
        className={props.className}
        style={{ color: "white" }}
        key={"home3"}
      >
        {props.children}
      </a>
    );
  }
  return result;
};

const SliderMenu = (props) => {
  // Prevents a flash of visible menu items when the entrance is triggered
  let extraClasses;
  if (props.active === null) {
    extraClasses = " dn";
  } else {
    extraClasses = props.active ? " fadeIn" : " fadeOut";
  }
  return (
    <div
      className={
        "flex flex-column justify-center items-center  top z-max w-100 ease sans-serif" +
        (props.active ? " vh-80" : " h0")
      }
      style={{ background: "#383f5c" }}
    >
      <Link
        to="/"
        style={{ color: "white" }}
        className={
          "display ttu dark-gray f3 no-underline menu__item pv4 " + extraClasses
        }
      >
        TRANG CHỦ
      </Link>
      {props.extraLinks.map((navLink, i) => (
        <MultiLink
          to={navLink.to}
          className={
            "ttu mid-gray f5 no-underline menu__item pv3" + extraClasses
          }
          key={i}
        >
          {navLink.name}
        </MultiLink>
      ))}
      <a
        href="/Identity/Account/Login"
        style={{ color: "white" }}
        className={"ttu mid-gray f5 no-underline menu__item pv3" + extraClasses}
      >
        ĐĂNG NHẬP
      </a>
    </div>
  );
};

export default class Navbar extends React.Component {
  constructor(props) {
    super();
    this.state = {
      // Null rather than false to check for initialization
      menuToggle: null,
      extraMenuClass: "",
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu(event) {
    this.setState({
      menuToggle: !this.state.menuToggle,
    });
  }

  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            site {
              siteMetadata {
                navbarLinks {
                  to
                  name
                }
                siteTitle: title
                mailChimpUrl
                siteUrl
              }
            }
          }
        `}
        render={(data) => (
          <React.Fragment>
            <div
              className="w-100 vh-7 justify-between items-center top-0 bb b--light-gray sans-serif"
              style={{
                position: "sticky",
                background: "#2a579a",
                zIndex: "5000",
              }}
            >
              <div
                className="flex w-100 vh-7 pv3 center justify-between items-center top-0 bb b--light-gray sans-serif"
                style={{
                  background: "#2a579a",
                  zIndex: "5000",
                  maxWidth: "77rem",
                }}
              >
                <div className="w-100 mw9 flex justify-between justify-around-l items-center ph4 pa2-ns">
                  <div className="dn-l">
                    <button
                      className="ttu tracked dark-gray f4 no-underline bn bg-transparent pointer"
                      onClick={this.toggleMenu}
                      style={{ color: "white" }}
                    >
                      <FiMenu />
                    </button>
                  </div>
                  <Link
                    to="/"
                    className={`ttu mid-gray f7 no-underline dn dib-l pa2`}
                    style={{
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: `${this.props.activeHome}`,
                    }}
                  >
                    Trang chủ
                  </Link>
                  <Link
                    to="/nhakhoahoc/"
                    className={`pa2 ttu mid-gray f7 no-underline dn dib-l`}
                    style={{
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: `${this.props.activeNhaKhoaHoc}`,
                    }}
                  >
                    NHÀ KHOA HỌC
                  </Link>
                  <Link
                    to="/baibaokhoahoc/"
                    className={`pa2 ttu mid-gray f7 no-underline dn dib-l`}
                    style={{
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: `${this.props.activeBaiBao}`,
                    }}
                  >
                    BÀI BÁO KHOA HỌC
                  </Link>
                  <Link
                    to="/detaikhoahoc/"
                    className={`pa2 ttu mid-gray f7 no-underline dn dib-l`}
                    style={{
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: `${this.props.activeDeTai}`,
                    }}
                  >
                    ĐỀ TÀI - DỰ ÁN - SÁNG KIẾN
                  </Link>
                  <Link
                    to="/giaotrinh/"
                    className={`pa2 ttu mid-gray f7 no-underline dn dib-l`}
                    style={{
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: `${this.props.activeGiaoTrinh}`,
                    }}
                  >
                    GIÁO TRÌNH
                  </Link>
                  <Link
                    to="/sachchuyenkhao/"
                    className={`pa2 ttu mid-gray f7 no-underline dn dib-l`}
                    style={{
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: `${this.props.activeSach}`,
                    }}
                  >
                    SÁCH PHỤC VỤ ĐÀO TẠO KHÁC
                  </Link>

                  <Link
                    to="/cthtquocte/"
                    className={`pa2 ttu mid-gray f7 no-underline dn dib-l`}
                    style={{
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: `${this.props.activeCTHTQuocTe}`,
                    }}
                  >
                    HỢP TÁC QUỐC TẾ
                  </Link>
                  <Link
                    to="/bieumau/"
                    className={`pa2 ttu mid-gray f7 no-underline dn dib-l`}
                    style={{
                      color: "white",
                      borderRadius: "30px",
                      backgroundColor: `${this.props.activeBieuMau}`,
                    }}
                  >
                    BIỂU MẪU
                  </Link>
                </div>
                <div className="ml5 dn w-100 mw4 flex-l justify-end items-center">
                  <a
                    href="/Identity/Account/Login"
                    className="ttu mid-gray f6 no-underline dn dib-l pa2"
                    style={{ color: "white", borderRadius: "30px" }}
                  >
                    ĐĂNG NHẬP
                  </a>
                </div>
              </div>
              <SliderMenu
                active={this.state.menuToggle}
                extraLinks={data.site.siteMetadata.navbarLinks}
                siteTitle={data.site.siteMetadata.siteTitle}
              />
            </div>
          </React.Fragment>
        )}
      />
    );
  }
}
